// extracted by mini-css-extract-plugin
export default {"tableBox":"SubUnitTable_tableBox__XMwoV","title":"SubUnitTable_title__miHb+"};